'use strict';

var $ = require('jquery');

$(function() {

    $('.searchbar_close').on('click', function(){
        $('body').toggleClass('noscroll');
        $('.searchbar').not('.searchbar__content').slideToggle();
        $('.searchbar_open').focus();
    });
    $('.searchbar_open').on('click', function(){
        if($(this).hasClass("mobile")){
            //close mobile menu before opening the search bar (when called inside mobile menu)
            $('#hamburger').toggleClass('open');
            $('.mobile-nav').slideToggle();
        }
        $('body').toggleClass('noscroll');
        $('.searchbar').not('.searchbar__content').slideToggle(
            {
                duration: 600
            }
        );
        $('#s').focus();
    });

    $('.searchbar').not('.searchbar__content').hide();

    $('.main-nav > a').on('mouseenter', function(){
        removeThemeColors();

        if($(this).data('menu-theme')){
            var theme_color = $(this).data('menu-theme');
            $('.bg-slide').each(function(){
                if($(this).data('type') == theme_color){
                    $(this).addClass('active');
                }
            });

        }
    });
    $('.main-nav > a').on('mouseleave', function(){
        removeThemeColors();
    });

    $('#hamburger').on('click', function(){
		$(this).toggleClass('open');
		$('.mobile-nav').slideToggle();
		$('body').toggleClass('mobile-menu__open');
        $('html,body').scrollTop(0);
        if($(this).hasClass('open')){
            $(this).attr('aria-expanded', 'true');
        }else{
            $(this).attr('aria-expanded', 'false');
        }
	});

    $('.toggle-submenu').on('click', function(){
        var menu = $(this).data('menu');
        $(this).toggleClass("open");

        if($(this).hasClass('open')){

            $(this).attr('aria-expanded', 'true');

        }else{

            $(this).attr('aria-expanded', 'false');

        }
        

        $('.mobile-nav_menu__sub').each(function(){
            if($(this).data('menu') == menu){
                $(this).slideToggle();
                $(this).prev().toggleClass('active wave wave__yellow');
                $(this).parent().toggleClass('active');
            }
        });
    });

    $(window).on('resize', function(){
        if($( this ).width() > 992){
            if($('.mobile-nav').height() > 0){
               	$('.mobile-nav').slideUp();
                $('#hamburger').removeClass('open');
                $('body').removeClass('mobile-menu__open');
            }
        }
    });

	$('.mobile-nav').css('height', $(document).height());

    $('.mobile-nav_menu .mobile-nav-item.active .toggle-submenu').addClass('open');
    $('.mobile-nav_menu .mobile-nav-item.active .toggle-submenu').attr('aria-expanded', 'true');


    

    $('.open-lang-nav').on('click', function(){

		$(this).toggleClass('open');

        if($(this).hasClass('open')){
            $(this).attr('aria-expanded', 'true');
        }else{
            $(this).attr('aria-expanded', 'false');
        }

        $('.language-menu').toggleClass('open');

	});


});

function removeThemeColors(){
    $('.bg-slide').removeClass('active');
}